import { useEffect, useState } from 'react';

import { Form } from '@arco-design/web-react';
import type { FormInstance } from '@arco-design/web-react';
import type { TFunction } from 'i18next';

import { readCpuTotal } from '../domain/cpu';
import { getCpuPrefix } from '../domain/paths';
import type { ComputePaths } from '../types';

export function useComputeModalCpuState(
  modalForm: FormInstance,
  modalPaths: Pick<ComputePaths, 'cpuCards' | 'cpuCores' | 'cpuLogical'>,
  cpuMax: number,
  t: TFunction,
) {
  const [cpuErr, setCpuErr] = useState('');
  const [cpuTotal, setCpuTotal] = useState(1);
  const cpuPrefix = getCpuPrefix(modalPaths as ComputePaths);
  const cpuWatch = Form.useWatch([modalPaths.cpuCards, modalPaths.cpuCores, modalPaths.cpuLogical], modalForm);

  useEffect(() => {
    setCpuTotal(readCpuTotal(modalForm.getFieldsValue(), cpuPrefix));
  }, [cpuPrefix, cpuWatch, modalForm]);

  const checkCpuLimit = (value: number | undefined, cb: (error?: string) => void) => {
    const total = readCpuTotal(modalForm.getFieldsValue(), cpuPrefix);
    setCpuTotal(total);
    if (!value) {
      cb(t('must-select'));
      setCpuErr('');
      return;
    }
    if (total > cpuMax) {
      const errMsg = `${t('cpu-core-num')} * ${t('cpu-core-core')} * ${t('cpu-logical-core')} = ${total}， ${t('limitlarge')}${cpuMax}`;
      setCpuErr(`${t('limitlarge')}${cpuMax}`);
      cb(errMsg);
      return;
    }
    setCpuErr('');
  };

  return { cpuErr, cpuTotal, checkCpuLimit };
}
